import React from 'react';
import { Button, List } from 'antd';
import { gql } from '@apollo/client';
import { useQuery } from 'hooks/apollo';
import Drawer from 'components/Drawer';
import useCustomer from 'hooks/useCustomer';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const QUERY = gql`
  query Segments {
    segments {
      id
      title
      createdBy {
        id
        email
      }      
    }
  }
`;

const SegmentListItem = ({ filterSegments, segment, onAdd }) => {
  const disabled = filterSegments.find(fs => fs.segment?.id === segment.id);
  return (
    <List.Item actions={[<Button onClick={() => onAdd(segment.id)} disabled={filterSegments.find(fs => fs.segment?.id === segment.id)}>{disabled ? 'Already added' : 'Add'}</Button>]}>
      {segment.title}
    </List.Item>
  );
};

const GlobalSegmentDrawer = ({ open, filterSegments, onSubmit, onClose }) => {
  const { data, loading } = useQuery(QUERY, { skip: !open });
  const { customer, loading: customerLoading, hasCustomerPermission } = useCustomer({ skip: !open, extraFields: 'segments { id title }' });

  const handleAddSegment = async (segmentId) => {
    await onSubmit({ segmentId });
  };

  const canEdit = hasCustomerPermission('EDIT_GLOBAL_SEGMENTS');

  const segments = [...customer?.segments || [], ...data?.segments || []];

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Global segments"
      footer={canEdit && <Link to="/tools/segments"><Button type="primary" onClick={onClose}>Manage segments</Button></Link>}
    >
      <List loading={loading || customerLoading}>
        {segments.map((segment) => (
          <SegmentListItem key={segment.id} segment={segment} filterSegments={filterSegments} onAdd={handleAddSegment} />
        ))}
      </List>
    </Drawer>
  );
};

export default GlobalSegmentDrawer;
